// utils/passwordValidator.js
// Standardized Password Validation & Complexity Rules

export const PASSWORD_REQUIREMENTS = [
  { key: "length", label: "At least 8 characters" },
  { key: "upper", label: "One uppercase letter (A-Z)" },
  { key: "lower", label: "One lowercase letter (a-z)" },
  { key: "number", label: "One number (0-9)" },
  { key: "special", label: "One special character (!@#$%^&*)" },
];

export function checkPasswordComplexity(password = "") {
  const length = password.length >= 8;
  const upper = /[A-Z]/.test(password);
  const lower = /[a-z]/.test(password);
  const number = /[0-9]/.test(password);
  const special = /[^A-Za-z0-9]/.test(password);

  const isValid = length && upper && lower && number && special;

  let error = "";
  if (!length) error = "Password must be at least 8 characters long.";
  else if (!upper) error = "Password must contain at least one uppercase letter (A-Z).";
  else if (!lower) error = "Password must contain at least one lowercase letter (a-z).";
  else if (!number) error = "Password must contain at least one number (0-9).";
  else if (!special) error = "Password must contain at least one special character (!@#$%^&*).";

  return {
    isValid,
    error,
    checks: {
      length,
      upper,
      lower,
      number,
      special,
    },
  };
}
